/**
 * Simplified version of the Modernizr.test function.
 * Used to add/remove hover listeners for touch devices
 * @type {boolean}
 */
export default (function () {
  return (typeof window !== 'undefined') &&
    (
      'ontouchstart' in window ||
      (
        window.DocumentTouch &&
        document instanceof DocumentTouch
      )
    );
})();



// WEBPACK FOOTER //
// ./frontend/react/sim/core/utils/isTouchDevice.js